import React from 'react';
import { buildClassName } from 'utils/build-class-name';
import ArrowIcon from 'components/icon/arrow-icon';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';

interface Props {
  isListingCardCarousel?: boolean;
  isLightbox: boolean | undefined;
  slideTo: (slide: 'next' | 'prev' | number) => void;
  className?: string;
  disableNext?: boolean;
  disablePrev?: boolean;
}

export default function CarouselArrows({ isListingCardCarousel, slideTo, className, isLightbox, disableNext, disablePrev }: Props) {
  const arrowClass = (type: 'next' | 'prev') => 
    buildClassName(styles.component, 
      styles[type], 
      isListingCardCarousel && styles.card, 
      isLightbox && styles.lightbox,
      disableNext && type === 'next' && styles.disabled,
      disablePrev && type === 'prev' && styles.disabled,
      className
    );

  return <>
    <span onClick={() => !disablePrev && slideTo('prev')} className={arrowClass('prev')} data-testid={testIds.carouselPrev}><ArrowIcon /></span>
    <span onClick={() => !disableNext && slideTo('next')} className={arrowClass('next')} data-testid={testIds.carouselNext}><ArrowIcon /></span>
  </>;
}
